import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { checkForUserLimit } from "../../../../utils";
import { USER_LIMITS } from "../../../../utils/constants";
import moment from "moment";
export const HeaderConfig = (userDetails) => {
  const result = [
    {
      label: "Defect",
      id: "defect",
    },
    {
      label: "OEM",
      id: "oem",
      render: (data) => {
        const oemNames = data?.oem?.map((ele) => ele.name);
        return (
          <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
            {oemNames?.join(", ")}
          </Box>
        );
      },
    },
    {
      label: "Engine Model",
      id: "engineModel",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.engineModel?.join(", ")}
        </Box>
      ),
    },
    {
      label: "List Numbers",
      id: "listNo",
      render: (data) => (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.listNo?.join(", ")}
        </Box>
      ),
    },

    { label: "Before Improvement", id: "beforeImprovement" },
    { label: "After Improvement", id: "afterImprovement" },

    { label: "Cut-in Esn", id: "cutInEsn" },

    {
      label: "Cut-in Effective Date",
      id: "cutInEffectiveDate",
      render: (data) => (
        <span>
          {data.cutInEffectiveDate &&
            moment(data.cutInEffectiveDate).format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      label: "Action",
      id: "action",
      render: (data, onClick) => (
        <Box sx={{ display: "flex" }}>
          <IconButton onClick={() => onClick("DOWNLOAD", data)}>
            <Icon
              icon="tabler:download"
              width="1.5rem"
              height="1.5rem"
              style={{ color: "#095adc" }}
            />
          </IconButton>
          {checkForUserLimit(
            USER_LIMITS.QUALITY_CREATOR,
            userDetails.limits
          ) && (
            <>
              <IconButton onClick={() => onClick("EDIT", data)}>
                <EditIcon color="primary" />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  color="error"
                  onClick={() => onClick("DELETE", data)}
                />
              </IconButton>
            </>
          )}
        </Box>
      ),
    },
  ];

  return result;
};
export const getIcaFormConfig = (oemsList, handleRegexSearch) => [
  {
    name: "defect",
    type: "text",
    label: "Defect",
    placeholder: "Defect",
    required: true,
  },
  {
    name: "beforeImprovement",
    type: "text",
    label: "Before Improvement",
    placeholder: "Before Improvement",
  },
  {
    name: "afterImprovement",
    type: "text",
    label: "After Improvement",
    placeholder: "After Improvement",
  },
  {
    name: "cutInEsn",
    type: "text",
    label: "Cut-in Esn",
    placeholder: "Cut-in Esn",
  },

  {
    name: "cutInEffectiveDate",
    type: "datePicker",
    label: "Cut-in Effective Date",
    placeholder: "Cut-in Effective Date",
  },
  {
    name: "oem",
    type: "autocomplete",
    label: "OEM Name",
    options: oemsList,
    placeholder: "Select Oem",
    multiple: true,
    required: true,
    onInputChange: handleRegexSearch,
  },
];
